// Taken from https://github.com/angular/angular/blob/main/packages/core/src/pending_tasks.ts

import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PhxPendingHttpTasks implements OnDestroy {
    private taskId = 0;
    private pendingTasks = new Set<number>();
    private get _hasPendingTasks() {
        return this.hasPendingTasks.value;
    }
    hasPendingTasks = new BehaviorSubject<boolean>(false);

    add(): number {
        if (!this._hasPendingTasks) {
            this.hasPendingTasks.next(true);
        }
        const taskId = this.taskId++;
        this.pendingTasks.add(taskId);
        return taskId;
    }

    remove(taskId: number): void {
        this.pendingTasks.delete(taskId);
        if (this.pendingTasks.size === 0 && this._hasPendingTasks) {
            this.hasPendingTasks.next(false);
        }
    }

    ngOnDestroy(): void {
        this.pendingTasks.clear();
        if (this._hasPendingTasks) {
            this.hasPendingTasks.next(false);
        }
    }
}
